import api from "./api";

export function findTableDetail() {
  return new Promise((resolve, reject) => {
    api
      .get("/vertis/postgres/table-detail")
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}